import { defineStore } from "pinia";
export const useUserStore = defineStore('user', {
    state: () => {
        return {
            songRegistrations: [],
            user: { name: '', app: false, auth: null, sub: null, at: '', ut: '', rt: '' },
        };
    },
});
